import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import CustomerNumberField from '../fields/customer-number-field/customer-number-field';
import IntersoftCredentialsStore from '../../../../stores/credentials/shipping/intersoft-credentials-store';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';

interface IProps {
    credentialsStore: IntersoftCredentialsStore,
    vGroup: IValidationGroup,
}

const IntersoftCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <CustomerNumberField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Royal Mail account number'
                note='Your Royal Mail account number'
            />
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Royal Mail posting location'
                note='Posting location ID given by carrier'
            />
            <FormFieldLine
                required
                label='RM Email Address'
                key='email_address'
                note='RM account Email Address'
            >
                <Input
                    value={credentialsStore.emailAddress}
                    onChange={credentialsStore.setEmailAddress}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default IntersoftCredentials;
